import PersonIcon from '@mui/icons-material/Person';
import { CardContent, Grid } from '@mui/material';
import React from 'react';
import { ExpandablePlayerCard } from '../../cards/playerCards/ExpandablePlayerCard';
import {
  AnimatedCard,
  AnimatedGrid,
  AnimatedStack,
  AnimatedTypography,
} from '../../MotionMui/MotionMui';
import { NewPackNewsCard } from './newpack/NewPackNewsCard';
import { UnfinishedMatch } from './unfinishedMatch/UnfinishedMatchCard';

export interface NewsCardProps {
  parent(children: any): any;
}

export const TeamNews = () => {
  const teamColours = (
    <AnimatedGrid item xs={12}>
      <AnimatedCard staggerSpeed={'Fast'}>
        <CardContent>
          <AnimatedTypography
            sx={{ fontSize: 14 }}
            color="text.secondary"
            gutterBottom
          >
            Coming soon
          </AnimatedTypography>
          <AnimatedTypography variant="h5" component="div">
            Team Colours <PersonIcon color="primary" />
          </AnimatedTypography>
          <AnimatedTypography variant="body2">
            Choose your colours! Unlock new kits and badges through challenges.
            What colour will you be?
          </AnimatedTypography>
        </CardContent>
      </AnimatedCard>
    </AnimatedGrid>
  );

  const italianLeague = (
    <AnimatedGrid item xs={12}>
      <AnimatedCard staggerSpeed={'Fast'}>
        <CardContent>
          <AnimatedTypography
            sx={{ fontSize: 14 }}
            color="text.secondary"
            gutterBottom
          >
            New League!
          </AnimatedTypography>
          <AnimatedTypography variant="h5" component="div">
            Serie Novante
          </AnimatedTypography>
          <AnimatedTypography variant="body2">
            The greatest players from 90s italian football. Unlock by completing
            the English league.
            <AnimatedStack
              staggerSpeed={'Fast'}
              direction="row"
              spacing={'8vw'}
              sx={{ marginTop: '4vmin' }}
            >
              {[
                'south-europe/italian-league/squadra-partenopea/hand-of-god',
                'south-europe/italian-league/diavoli-immortali/lich-king-of-milan',
                'south-europe/italian-league/rettili-nerazzurri/ronaldo-lizario',
                'south-europe/italian-league/giglio-ardente/batigol',
              ]
                .map((playerId) => {
                  return {
                    id: playerId,
                    collectionId: 'world-tour',
                  };
                })
                .map((player) => {
                  return (
                    <ExpandablePlayerCard key={player.id} player={player} />
                  );
                })}
            </AnimatedStack>
          </AnimatedTypography>
        </CardContent>
      </AnimatedCard>
    </AnimatedGrid>
  );

  const parent = (children: any) => {
    return (
      <Grid item xs>
        {children}
      </Grid>
    );
  };
  return (
    <AnimatedGrid container spacing={2} staggerSpeed={'Normal'}>
      <NewPackNewsCard parent={parent} />
      <UnfinishedMatch parent={parent} />
      {italianLeague}
      {teamColours}
    </AnimatedGrid>
  );
};
